module.exports = __webpack_public_path__ + "static/media/SincerelyDiary.e9005d4c.jpg";